import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(
	theme => ({
		modal: {
			display: 'flex',
			flexDirection: 'column',
			overflow: 'auto',
			transform: 'translate(0)',
		},
		fade: {
			width: '100%',
			maxWidth: theme.spacing(58),
			margin: 'auto',
			outline: 'none',
			transition: 'margin-top 0.05s',
		},
		paper: {
			transition: theme.transitions.create(['background-color']),
			boxShadow: theme.shadows[5],
			borderRadius: '11px',
			padding: theme.spacing(4),
			outline: 'none',
			position: 'relative',
		},
		backDrop: {
			background: 'none',
			'&:after': {
				position: 'absolute',
				width: 1,
				height: 1,
				top: '50%',
				left: '50%',
				content: '""',
				boxShadow: '0 0 0 1000vw rgba(0, 0, 0, 0.5)',
			},
		},
		close: {
			position: 'absolute',
			top: theme.spacing(2),
			right: theme.spacing(2),
			cursor: 'pointer',
			color: theme.palette.grey[700],
		},
	}),
	{ name: 'Popup-PopupModal' },
)

export default useStyles
